define.alias("shared/helpers/time-ago", "preview-grid/helpers/time-ago");